export var validateEmail = function validateEmail(emailValue) {
  var emailRegex = /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/;

  if (emailRegex.test(emailValue)) {
    return "";
  }

  return "Please make sure you are using a valid email format.";
};
export var validateTel = function validateTel(telValue) {
  var telRegex = /([+?0-9\s-]{2,})?([(?0-9\s\-.)]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;

  if (telRegex.test(telValue)) {
    return "";
  }

  return "For phone number use numerals only; no dashes.";
};
export var validateFormData = function validateFormData(formElement) {
  var emailInput = formElement.querySelector("input[type=email]");
  var telInput = formElement.querySelector("input[type=tel]");
  var errors = [];
  errors.push(emailInput && emailInput.required ? validateEmail(emailInput.value) : "");
  errors.push(telInput && telInput.required ? validateTel(telInput.value) : "");
  return errors.filter(function (error) {
    return error !== "";
  });
};